import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { formatToZMW, rootUrl } from '../../helpers';
import { useAuth } from '../../context/auth-context';
import { toast } from 'react-toastify';
import { FaMoneyBill, FaPlus, FaBuilding, FaChartLine, FaDollarSign, FaExclamationTriangle } from 'react-icons/fa';
import Modal from '../../components/Modal';
import FormGenerator from '../../components/formGenerator';

export default function Budget() {

    const [budget, setBudget] = useState([]);
    const [coa, setCoa] = useState([]);
    const [dept, setDept] = useState([]);
    const [program, setProgram] = useState([]);
    const [subProgram, setSubProgram] = useState([]);
    const [output, setOutput] = useState([]);
    const [units, setUnits] = useState([]);
    const [councils, setCouncil] = useState([]);
    const [amounts, setAmounts] = useState([]);

    const auth = useAuth();

    const fetchData = async () => {
        try{
            const data = await axios.get(rootUrl(`/getProjects/${auth.user.id}`))
            setBudget(data.data.data.budget);
            setCoa(data.data.data.coa);
            setDept(data.data.data.dept);
            setProgram(data.data.data.program);
            setSubProgram(data.data.data.subProgram);
            setOutput(data.data.data.output);
            setUnits(data.data.data.units);
            setCouncil(data.data.data.councils);

        }catch(e){
            toast.error(e?.message)
        }
    }

    const getData = async () => {
        try{
            const data = await axios.get(rootUrl(`/getDeptAmount/${auth.user.cid}`))
            setAmounts(data.data.data)
        }catch(e){
            toast.error(e?.message)
        }
    }

    useEffect(()=>{
        getData()
    },[])

    useEffect(()=>{
        fetchData()
    },[amounts])


    const fields = [
        {type: 'select', name: 'departmentCode', label: 'Department', required: true, dependentFields: ['unit'], options: dept.map(res => ({
            value: res.id,
            label: res.name,
          }))},
          {type: 'number', name: 'amount', label: 'Amount', required: true},
    ]

    const [modal, setModal] = useState({title:'', open:false, body:'', size:'sm'})
    const handleClose = () => {
        setModal({...modal, open: false })   
    }

    const submitSetting = async (data)=>{
        data['councilCode'] = auth.user.cid;
        data['addedBy'] = auth.user.id;

        try{
            const response = await axios.post(rootUrl(`/addDeptAmount`), data)
            if(response.data.status == 200){
                toast.success('Submitted successfully')
                getData()
                setModal({...modal, open: false })  
            }else{
                toast.error(response.data.message)
            }
        }catch(e){
            toast.error(e?.message)
        }
    }

    const addSett = async () => {
        setModal({
            title:'Add Amount',
            open:true,
            size:'sm',
            body:<FormGenerator fields={fields} onSubmit={submitSetting} />
              })
    }
    

   

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <FaMoneyBill className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Budget Management</h1>
              <p className="text-blue-100 text-sm mt-1">Department budget allocation and tracking</p>
            </div>
          </div>
          <button 
            onClick={()=>addSett()} 
            className="flex items-center gap-2 px-4 py-2.5 bg-white text-blue-950 rounded-lg hover:bg-blue-50 transition-colors font-medium shadow-sm"
          >
            <FaPlus />
            <span>Add Amount</span>
          </button>
        </div>
      </div>

      {/* Budget Table */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gradient-to-r from-blue-950 to-blue-800 text-white">
                <th className="px-6 py-4 text-left font-semibold text-sm">
                  <div className="flex items-center gap-2">
                    <FaBuilding className="text-sm" />
                    <span>Department</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-right font-semibold text-sm">
                  <div className="flex items-center justify-end gap-2">
                    <FaDollarSign className="text-sm" />
                    <span>Allocated Amount</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-right font-semibold text-sm">
                  <div className="flex items-center justify-end gap-2">
                    <FaChartLine className="text-sm" />
                    <span>Budgeted Amount</span>
                  </div>
                </th>
                <th className="px-6 py-4 text-right font-semibold text-sm">
                  <div className="flex items-center justify-end gap-2">
                    <FaExclamationTriangle className="text-sm" />
                    <span>Variance</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {dept && dept.length > 0 ? (
                <>
                  {dept.map((res) => {
                    const amount = amounts.find(a => a.departmentCode === res.id)?.amount || 0;
                    const budgetTotal = budget
                      .filter(a => a.dept === res.id && a.coa.substring(0,1) !== '1')
                      .map(row => parseFloat(row.price) * parseFloat(row.qty) * parseFloat(row.frequency))
                      .reduce((a, b) => a + b, 0);
                    const balance = amount - budgetTotal;
                    const isNegative = balance < 0;
                    return (
                      <tr key={res.id} className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 text-gray-900 font-medium">{res.name}</td>
                        <td className="px-6 py-4 text-right text-gray-700">{formatToZMW(amount)}</td>
                        <td className="px-6 py-4 text-right text-gray-700">{formatToZMW(budgetTotal)}</td>
                        <td className={`px-6 py-4 text-right font-medium ${isNegative ? 'text-red-600' : 'text-green-600'}`}>
                          {formatToZMW(balance)}
                        </td>
                      </tr>
                    );
                  })}

                  {/* Totals Row */}
                  <tr className="bg-gradient-to-r from-gray-100 to-gray-50 border-t-2 border-gray-300">
                    <td className="px-6 py-4 font-bold text-gray-900">Total</td>
                    <td className="px-6 py-4 text-right font-bold text-gray-900">
                      {formatToZMW(dept
                        .map(res => parseFloat(amounts.find(a => a.departmentCode === res.id)?.amount || 0))
                        .reduce((a, b) => a + b, 0)
                      )}
                    </td>
                    <td className="px-6 py-4 text-right font-bold text-gray-900">
                      {formatToZMW(dept
                        .map(res => budget
                          .filter(a => a.dept === res.id && a.coa.substring(0,1) !== '1')
                          .map(row => parseFloat(row.price) * parseFloat(row.qty) * parseFloat(row.frequency))
                          .reduce((a, b) => a + b, 0)
                        )
                        .reduce((a, b) => a + b, 0)
                      )}
                    </td>
                    <td className="px-6 py-4 text-right font-bold text-gray-900">
                      {formatToZMW(dept
                        .map(res => {
                          const amount = amounts.find(a => a.departmentCode === res.id)?.amount || 0;
                          const budgetTotal = budget
                            .filter(a => a.dept === res.id && a.coa.substring(0,1) !== '1')
                            .map(row => parseFloat(row.price) * parseFloat(row.qty) * parseFloat(row.frequency))
                            .reduce((a, b) => a + b, 0);
                          return amount - budgetTotal;
                        })
                        .reduce((a, b) => a + b, 0)
                      )}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="4" className="px-6 py-12 text-center">
                    <FaBuilding className="text-gray-400 text-5xl mx-auto mb-4" />
                    <p className="text-gray-600 font-medium">No departments found</p>
                    <p className="text-gray-500 text-sm mt-2">Add departments to get started</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {modal.open && (
        <Modal title={modal.title} onClose={handleClose}>
          {modal.body}
        </Modal>
      )}
    </div>
  )
}
